export const ADVISOR_CLIENT_PLAN_SELECTED = 'ADVISOR_CLIENT_PLAN_SELECTED'